import type { FC } from 'react';
import { TableRow, useTheme } from '@mui/material';

import type { ActionItemStatus, NpsGroup } from 'src/types/followUp';
import { internationalDateFormat } from 'src/helper/helper';

import NpsScore from './Cells/NpsScore';
import StatusPill from './Cells/StatusPill';
import TicketTableCell from './Cells/TicketTableCell';

export interface TicketTableRowProps {
  id: number;
  npsScore: number;
  npsGroup: NpsGroup;
  respondentName: string;
  followUpOwnerName: string;
  createdAt: string;
  lastModifiedAt?: string | null;
  firstContactAt: string;
  status: ActionItemStatus;
  dueAt: string;
  onClick: () => void;
}

const TicketTableRow: FC<TicketTableRowProps> = ({
  id,
  npsScore,
  npsGroup,
  firstContactAt,
  status,
  followUpOwnerName,
  respondentName,
  lastModifiedAt,
  createdAt,
  dueAt,
  onClick,
}) => {
  const theme = useTheme();
  return (
    <TableRow
      onClick={onClick}
      sx={(theme) => ({
        ':hover': {
          cursor: 'pointer',
          backgroundColor: theme.colors.neutral[100],
        },
      })}
    >
      <TicketTableCell>{id}</TicketTableCell>
      <TicketTableCell>{npsGroup}</TicketTableCell>
      <TicketTableCell>
        <NpsScore score={npsScore} />
      </TicketTableCell>
      <TicketTableCell>{respondentName}</TicketTableCell>
      <TicketTableCell>{followUpOwnerName}</TicketTableCell>
      <TicketTableCell>
        {internationalDateFormat(new Date(createdAt))}
      </TicketTableCell>
      <TicketTableCell>
        {lastModifiedAt
          ? internationalDateFormat(new Date(lastModifiedAt))
          : '-'}
      </TicketTableCell>
      <TicketTableCell
        sxOverride={
          !firstContactAt && status === 'Overdue'
            ? {
                color: theme.colors.error[500],
                fontWeight: 700,
              }
            : {}
        }
      >
        {internationalDateFormat(new Date(firstContactAt ?? dueAt))}
      </TicketTableCell>
      <TicketTableCell>
        <StatusPill status={status} />
      </TicketTableCell>
    </TableRow>
  );
};

export default TicketTableRow;
